import { CSSProperties, memo, useMemo } from "react"
import { OrderStatus, SecondaryOrderStatus } from "../../proto/generated/order";
import { getOrderStatusColor, getOrderStatusText } from "../../util/orders";

export type OrderStatusProps = {
    status: OrderStatus,
    secondaryStatus?: SecondaryOrderStatus,
    style?: CSSProperties
    executedAsTriggered?: boolean
}

const OrderStatusDisplay: React.FC<OrderStatusProps> = ( {status, secondaryStatus, style = {}, executedAsTriggered} ) => {

    const mergedStyles: CSSProperties = useMemo(
        () => ({ ...style, color: getOrderStatusColor(status, { executedAsTriggered })}),
        [status, style, executedAsTriggered]
    )
    return <span style={mergedStyles} >{getOrderStatusText(status, secondaryStatus, { executedAsTriggered })}</span>;
}

export default memo(OrderStatusDisplay)
